import { MongoAbility } from '@casl/ability'

export enum ABILITY_ACTIONS {
  'create' = 'create',
  'read' = 'read',
  'update' = 'update',
  'delete' = 'delete',
  'sign' = 'sign',
  'download' = 'download',
}

export enum ABILITY_SUBJECTS {
  'Document' = 'Document',
  'SystemSettings' = 'SystemSettings',
  'Session' = 'Session',
  'Certificate' = 'Certificate',
}
// Türkçe çeviri haritaları

export const ABILITY_ACTIONS_TR = {
  [ABILITY_ACTIONS.create]: 'Oluştur',
  [ABILITY_ACTIONS.read]: 'Görüntüle',
  [ABILITY_ACTIONS.update]: 'Güncelle',
  [ABILITY_ACTIONS.delete]: 'Sil',
  [ABILITY_ACTIONS.sign]: 'İmzala',
  [ABILITY_ACTIONS.download]: 'İndir',
} as const

export const ABILITY_SUBJECTS_TR = {
  [ABILITY_SUBJECTS.Document]: 'Belge',
  [ABILITY_SUBJECTS.SystemSettings]: 'Sistem Ayarları',
  [ABILITY_SUBJECTS.Session]: 'Oturum',
  [ABILITY_SUBJECTS.Certificate]: 'Sertifika',
} as const
// Çeviri fonksiyonları

export function getActionLabel(action: keyof typeof ABILITY_ACTIONS): string {
  return ABILITY_ACTIONS_TR[action] || action
}

export function getSubjectLabel(
  subject: keyof typeof ABILITY_SUBJECTS,
): string {
  return ABILITY_SUBJECTS_TR[subject] || subject
}

export function getPermissionLabel(
  action: keyof typeof ABILITY_ACTIONS,
  subject: keyof typeof ABILITY_SUBJECTS,
): string {
  return `${getActionLabel(action)} - ${getSubjectLabel(subject)}`
}

export interface AbilityConfig {
  action: ABILITY_ACTIONS
  subject: ABILITY_SUBJECTS
  type: 'can' | 'cannot'
  label: string[]
}

export enum API_ABILITIES {
  getAllCertificates = 'getAllCertificates',
  signData = 'signData',
  readDocuments = 'readDocuments',
  downloadDocuments = 'downloadDocuments',
  deleteDocument = 'deleteDocument',
  updateDocument = 'updateDocument',
  getSessions = 'getSessions',
  getOwnedTeamSettings = 'getOwnedTeamSettings',
  updateOwnedTeamSettings = 'updateOwnedTeamSettings',
}

const apiAbilities: Record<API_ABILITIES, AbilityConfig> = {
  [API_ABILITIES.getAllCertificates]: {
    action: ABILITY_ACTIONS.read,
    subject: ABILITY_SUBJECTS.Certificate,
    type: 'cannot',
    label: ['Sertifika listesini görüntüleme'],
  },
  [API_ABILITIES.signData]: {
    action: ABILITY_ACTIONS.sign,
    subject: ABILITY_SUBJECTS.Document,
    type: 'cannot',
    label: [
      'Veri imzalama',
      'Uyap Girişi Başlatma',
      'Evrak imzalama',
      'Evrakı imzalamak üzere sisteme yükleme',
    ],
  },
  [API_ABILITIES.readDocuments]: {
    action: ABILITY_ACTIONS.read,
    subject: ABILITY_SUBJECTS.Document,
    type: 'cannot',
    label: [
      'Kullanıcı evraklarını görüntüleme',
      'Kişisel evrak listesini görme',
      'Takım evraklarını görüntüleme',
      'Takımdaki tüm evrakları listeleme',
    ],
  },
  [API_ABILITIES.downloadDocuments]: {
    action: ABILITY_ACTIONS.download,
    subject: ABILITY_SUBJECTS.Document,
    type: 'cannot',
    label: ['İmzalı evrakı indirme'],
  },
  [API_ABILITIES.deleteDocument]: {
    action: ABILITY_ACTIONS.delete,
    subject: ABILITY_SUBJECTS.Document,
    type: 'cannot',
    label: [
      'Evrak silme',
      'İmzalı evrakı sistemden kaldırma',
      'Tüm evrakları silme',
      'Kullanıcının tüm evraklarını kaldırma',
    ],
  },
  [API_ABILITIES.updateDocument]: {
    action: ABILITY_ACTIONS.update,
    subject: ABILITY_SUBJECTS.Document,
    type: 'cannot',
    label: ['Evrak durumunu güncelleme', 'Evrak yasaklama durumunu değiştirme'],
  },
  [API_ABILITIES.getSessions]: {
    action: ABILITY_ACTIONS.read,
    subject: ABILITY_SUBJECTS.Session,
    type: 'cannot',
    label: [
      'Oturum listesini görüntüleme',
      'Aktif oturumları listeleme',
      'UYAP oturumunu kullanma',
    ],
  },
  // [API_ABILITIES.deleteSessions]: {
  //   action: ABILITY_ACTIONS.delete,
  //   subject: ABILITY_SUBJECTS.Session,
  //   type: 'cannot',
  //   label: ['Oturum silme', 'Aktif oturumu sonlandırma'],
  // },
  [API_ABILITIES.getOwnedTeamSettings]: {
    action: ABILITY_ACTIONS.read,
    subject: ABILITY_SUBJECTS.SystemSettings,
    type: 'cannot',
    label: ['Takım ayarlarını görüntüleme'],
  },
  [API_ABILITIES.updateOwnedTeamSettings]: {
    action: ABILITY_ACTIONS.update,
    subject: ABILITY_SUBJECTS.SystemSettings,
    type: 'cannot',
    label: ['Takım ayarlarını güncelleme'],
  },
}

export function getApiAbilityConfig(
  apiName: API_ABILITIES,
): AbilityConfig | undefined {
  return apiAbilities[apiName]
}

export function hasApiPermission(
  apiName: API_ABILITIES,
  userAbility: MongoAbility,
): boolean {
  const config = getApiAbilityConfig(apiName)

  if (!config) {
    return true
  }

  if (config.type === 'cannot') {
    return userAbility.cannot(config.action, config.subject)
  } else {
    return userAbility.can(config.action, config.subject)
  }
}

export function getAllApiAbilities() {
  return apiAbilities
}

export function getApiDescription(apiName: API_ABILITIES): string[] {
  const config = getApiAbilityConfig(apiName)
  return config?.label || []
}
